import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { forgotPassword } from "../../actions/auth";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import logo from "../../assets/images/salek-logo.webp";
import brandsekLoginBanner from "../../assets/images/forget.png";

class ForgotPassword extends Component {
  resetPassword = (e) => {
    e.preventDefault();
    let email = $("#email").val();
    if (email === "") {
      toastr.error("Error", "Please enter email");
      return false;
    }
    this.props.forgotPassword({ email });
  };

  render() {
    return (
      <div className="page-wrapper page-wrapper_login">
        <div className="section bg-default wf-section">
          <div className="container-fluid p-0">
            <div className="row m-0" style={{ display: "flex", alignItems: "center", height: "100vh" }}>
              <div className="col-md-7 p-0">
                <div className="login-image">
                  <img src={brandsekLoginBanner} alt="brandsek" />
                  <h2 className="login-image-heading">Forgot your password? Recover access securely and stay protected.</h2>
                </div>
              </div>
              <div className="col-md-5 p-0">
                <div className="sign-form sign-form-forgot w-form">
                  <form className="form-auth-small m-t-20">
                    <div className="sign-card-content">
                      <div className="loginContentBox">
                        <img src={logo} className="img-fluid" alt="brandsek" />
                        <h2 className="display-2 text-center mg-bottom-24px keep">Forgot Password</h2>
                        <p className="text-center mg-bottom-24px keep"
                        >Know your Password? <Link to="/login">Login</Link></p>
                      </div>
                      <div className="mg-bottom-24px keep">
                        <div>
                          <label htmlFor="email" className="form-label">Email Address</label>
                          <input type="email" className="input input-form w-input" id="email" name="Email" placeholder="Email address" />
                        </div>
                      </div>
                      <button type="submit" className="loginButton btn-primary width-100 w-button" onClick={this.resetPassword}>Reset Password</button>
                    </div>
                  </form>
                  <div style={{ textAlign: 'center', padding: '10px', fontSize: '14px', color: '#666', marginTop:'20px' }}>
                    Powered by brandsek
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ forgotPassword }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
